import React, { useMemo } from 'react';
import { useTranslation } from "react-i18next";
import { Button } from "@material-ui/core";
import Loading from "../../util/Loading";
import {useSubscription} from "../../../hooks/useSubscription";
import { ArrowForwardIos } from "@material-ui/icons";
import {Source} from "../types.d"
import Styles from "../../../scss/subscriptions.module.scss";
import useFormatCurrency from '../../../yoello-lib/modules/localisation/useCurrency';

interface ICard {
    content?: React.ReactNode,
    buttonTitle?: string,
    onClick?: any,
    disabled?: boolean,
    url?:string|null
}
const Arrows = () => <ArrowForwardIos fontSize={"inherit"} style={{ marginLeft: '8px' }} />
export function Card(props: ICard) {
  const { t } = useTranslation();
  const { OnboardingSource, FeesPlan, isLoading } = useSubscription();
  const { currency } = useFormatCurrency()

  const isDirectMerchant: boolean = useMemo(() => {
    return OnboardingSource === (Source.Yoello || Source.ZeroBubble || Source.BNA)
  }, [OnboardingSource])

  if (!OnboardingSource || isLoading){
    return <Loading/>
  }

  return (
    <>
      {isDirectMerchant ?
        <div className={Styles.DirectMerchant}>
            <header>
              {t(`subscription.transactionFee${currency?.symbol}`, { percent: FeesPlan?.order_processing_charge_percentage, price: FeesPlan?.order_processing_charge })}
            </header>
        </div> :
        <div className={Styles.BarclayCard}>
          <header>
              {t("subscription.barclaycard.plan.transactionFee", { TransactionFee: FeesPlan?.order_processing_charge })}
          </header>
          {props?.content && <p> {props?.content} </p>}
          {props.url ? <a 
           href={props.url}
           target={"_blank"}
           style={{ textDecoration: "none" }}
           rel="noopener noreferrer"
          >
              <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  disabled={props?.disabled}
                >
                  {props?.buttonTitle}
                  <Arrows />
              </Button>
          </a>:
            <Button
              variant="contained"
              color="primary"
              size="large"
              disabled={props?.disabled}
              onClick={props?.onClick}
            >
              {props?.buttonTitle}
              <Arrows />
            </Button>
          }
        </div>
      }
    </>
  )
}
